const state = {
    emailtemplate: [],
    emailtemplateid: null,
    loading: false,
    platformTypeList : [],
    contentTemplate : [],
    contentTemplateId: []
};

export default state;